<!--  -->
<template>
  <div class="apply-type">
    <!--可以考虑js去写监听页面像素宽-->
    <div class="apply-steps">
      <div>
        <Steps :current="curIndex">
          <Step title="Capacity"></Step>
          <Step title="Interview"></Step>
          <Step title="Contract"></Step>
          <Step title="Training/Test"></Step>

        </Steps>
      </div>
    </div>
    <div class="apply-steps2">
      <div>
        <Steps :current="curIndex"
               direction="vertical">
          <Step title="Capacity"></Step>
          <Step title="Interview"></Step>
          <Step title="Contract"></Step>
          <Step title="Training/Test"></Step>

        </Steps>
      </div>
    </div>
    <div class="apply-container">
      <component :is="componentId"
                 type="SMCM"
                 @on-success="successHandle"
                 v-model="applyId"
                 :mentorData="mentorData"></component>
    </div>
  </div>
</template>

<script>
// api
import { applyMentorStepsSM } from '@/api/apply'
// components
import SmCapacity from './components/sm-capacity'
import SmInterview from './components/interview'
import SmContract from './components/contract'
import SmTrainingTest from './components/sm-training-test'

export default {
  name: 'apply-sm',
  components: {
    SmCapacity,
    SmInterview,
    SmContract,
    SmTrainingTest
  },
  data () {
    return {
      componentId: 'SmCapacity',
      applyId: '',
      curIndex: 0,
      mentorData: ''
    }
  },
  computed: {},
  mounted () {
    this.getSteps()
  },
  methods: {
    // 获取步骤
    getSteps () {
      applyMentorStepsSM({}).then(res => {
        let result = res.data.result
        this.mentorData = result
        this.applyId = result.applyId
        this.statusStep(result.status)
      })
    },
    // 保存成功
    successHandle () {
      this.getSteps()
    },
    // 映射步骤
    statusStep (val) {
      let index = 0
      switch (val) {
        case 'NEW_APPLY':
        case 'FIRSTPASS':
        case 'INTERVIEW':
        case 'ALLOCATED':
          index = 1
          break
        case 'PASS':
          index = 2
          break
        case 'HAS_SIGN':
          index = 3
          break
        case 'FAIL':
        case 'TRAINING_TEST_PASS':
        case 'ACTIVE':
        case 'INACTIVE':
          index = -1
          break
        default:
          index = 0
      }
      this.curIndex = index
    }
  },
  watch: {
    curIndex (val) {
      if (val === -1) {
        this.$router.replace({
          name: 'apply-select'
        })
        return false
      }
      let name = ''
      switch (val) {
        case 0:
          name = 'SmCapacity'
          break
        case 1:
          name = 'SmInterview'
          break
        case 2:
          name = 'SmContract'
          break
        case 3:
          name = 'SmTrainingTest'
          break
      }
      this.componentId = name
    }
  }
}
</script>
<style lang='less' scoped>
</style>
